import { DeepPartial } from 'redux';
import { FeeText, JarvisPriceType } from '../../enum';
import { JarvisHomebox, JarvisPrice } from '../../interface';
import { getCMSConfig } from '../cms';
import { getRouterPriceProps } from './promoPriceHelper';
import {
    IOfferSummaryCardAdditionalPrice,
    IOfferSummaryCardPromoPrice,
} from '@vfde-brix/ws10/offer-summary-card';
import { Price } from '@vfde-brix/ws10/core';

/**
 * Gets subline texts
 *
 * @param isContentEnabled - If content is enabled
 * @returns - Return subline text array
 */
export const getSublineTexts = (isContentEnabled: boolean) => {
    return !isContentEnabled ? [getCMSConfig().offerSummaryCard.notAvailable.subline] : [];
};

/**
 * Gets router price props
 *
 * @param price - Router price
 * @param isContentEnabled - If cotent is enabled
 * @returns - Array of price props
 */
export const getPriceProps = (
    price: JarvisPrice,
    isContentEnabled: boolean
): DeepPartial<IOfferSummaryCardPromoPrice>[] => {
    return isContentEnabled ? [getRouterPriceProps(price)] : [];
};

/**
 * Gets addigitonal prices for offer summary card
 *
 * @param router - Selected router
 * @returns - Additional prices array
 */
export const getAdditionalPrices = (
    router: JarvisHomebox,
    isContentEnabled: boolean
): Partial<IOfferSummaryCardAdditionalPrice>[] => {
    if (!isContentEnabled){
        return [];
    }

    const additionalPrices: Partial<IOfferSummaryCardAdditionalPrice>[] = [];

    if (router.price.type === JarvisPriceType.STAIRWAY && router.price.stairway){
        additionalPrices.push({
            price: Price.fromNumber(router.price.value),
            txtLabel: `ab dem ${router.price.stairway.period.toString()}. Monat`,
        });
    }

    if (router.provisionFee) {
        additionalPrices.push({
            price: Price.fromNumber(router.provisionFee),
            txtLabel: FeeText.PROVISION_FEE,
        });
    }

    if (router.deliveryFee) {
        additionalPrices.push({
            price: Price.fromNumber(router.deliveryFee),
            txtLabel: FeeText.ROUTER_DELIVERY_FEE,
        });
    }

    return additionalPrices;
};
